import {
  getFeaturesByTitle,
  filterFeaturesByTitle
} from 'components/direct-sales/quote/utils';

import type { TProduct } from 'api/models/TProduct';

export const HANDLED_FEATURES = {
  PILL: 'pill', // deprecated
  HIGHLIGHT: 'highlight', // replaces PILL. treated same as pill
  CTA_CARD: 'ctaCard',
  EXIT_FEE: 'exitFee',
  EXIT_FEE_DETAILS: 'exitFeeDetails',
  NUCLEUS_PILL: 'nucleus-pill',
  TARIFF_STANDOUT: 'tariff-standout'
};

export const useTariffHighlightFeatures = (product: TProduct = {}) => {
  const { features = [] } = product;

  return [
    ...getFeaturesByTitle(features, [HANDLED_FEATURES.PILL]), // deprecated
    ...getFeaturesByTitle(features, [HANDLED_FEATURES.HIGHLIGHT])
  ];
};

export const usePillFeatures = (product: TProduct = {}) => {
  const { features = [] } = product;

  return getFeaturesByTitle(features, [HANDLED_FEATURES.NUCLEUS_PILL]);
};

export const useTariffStandoutFeatures = (product: TProduct = {}) => {
  const { features = [] } = product;

  return getFeaturesByTitle(features, [HANDLED_FEATURES.TARIFF_STANDOUT]);
};

export const useCtaCardFeatures = (product: TProduct = {}) => {
  const { features = [] } = product;

  return getFeaturesByTitle(features, [HANDLED_FEATURES.CTA_CARD]);
};

export const useExitFeeFeatures = (product: TProduct = {}) => {
  const { features = [] } = product;

  return getFeaturesByTitle(features, [
    HANDLED_FEATURES.EXIT_FEE,
    HANDLED_FEATURES.EXIT_FEE_DETAILS
  ]).sort((f) => (f.title === HANDLED_FEATURES.EXIT_FEE ? -1 : 1));
};

export const useTariffFeatures = (product: TProduct = {}) => {
  const { features = [] } = product;
  const tagFilters = Object.values(HANDLED_FEATURES);

  return filterFeaturesByTitle(features, tagFilters);
};
